/**
 * hiển thị thêm dòng theo
 */
export default {
  BudgetSourceGroupPropertyType: 1, // tính chất nguồn
  DescriptionVoucher: 2, // diễn giải chứng từ
};
